var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "music-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 11.1513V3.25H16V4.75H11.5V13.75C11.4999 14.4104 11.2818 15.0522 10.8797 15.5761C10.4776 16.0999 9.91387 16.4764 9.27597 16.6472C8.63807 16.818 7.96164 16.7736 7.35157 16.5208C6.74149 16.268 6.23188 15.821 5.90176 15.249C5.57164 14.6771 5.43945 14.0122 5.5257 13.3575C5.61195 12.7028 5.91182 12.0948 6.3788 11.6279C6.84578 11.161 7.45378 10.8612 8.10851 10.775C8.76324 10.6888 9.4281 10.8211 10 11.1513ZM8.5 15.25C8.89783 15.25 9.27936 15.092 9.56066 14.8107C9.84197 14.5294 10 14.1478 10 13.75C10 13.3522 9.84197 12.9706 9.56066 12.6893C9.27936 12.408 8.89783 12.25 8.5 12.25C8.10218 12.25 7.72065 12.408 7.43934 12.6893C7.15804 12.9706 7 13.3522 7 13.75C7 14.1478 7.15804 14.5294 7.43934 14.8107C7.72065 15.092 8.10218 15.25 8.5 15.25Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.72ef5dac982bdc8cd491ca8eb7f8c3b4.svg";
export { ForwardRef as ReactComponent };